import { Link } from "react-router-dom";
import RecordsTable from "./RecordsTable";
import PageMeta from "./PageMeta";

export default function ContentPage() {
  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta title="Club Content Overview | Redruth Sea Angling Association" noindex />
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-12">
        <Link
          to="/"
          className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20"
        >
          ← Back
        </Link>

        <h1 className="heading-glow mt-8 text-4xl font-bold tracking-tight text-white sm:text-5xl">
          Club content overview
        </h1>

        <p className="mt-4 text-lg leading-8 text-slate-300">
          This page gathers your most important club information in one place for members and guests. You can use it as a friendly one-page summary of the club’s mission, fixtures, and key links.
        </p>

        <div className="mt-10 space-y-6 rounded-2xl border border-white/10 bg-white/5 p-6 shadow-lg shadow-cyan-950/25 backdrop-blur">
          <section>
            <h2 className="text-2xl font-semibold text-cyan-200">About Redruth Sea Angling</h2>
            <p className="mt-2 text-slate-300">
              Redruth Sea Angling Association is a Cornwall-based club providing shore and boat competition opportunities
              for anglers of all levels, with a strong catch-and-release ethos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-cyan-200">Current membership and fixtures</h2>
            <ul className="mt-2 list-disc space-y-2 pl-5 text-slate-300">
              <li>Annual membership: £15</li>
              <li>Tide times and fixture schedules are updated regularly.</li>
              <li>New member onboarding and club events are a priority.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-cyan-200">Helpful quick links</h2>
            <div className="mt-3 grid gap-3 sm:grid-cols-2">
              <Link
                to="/"
                className="rounded-lg border border-cyan-300/30 bg-cyan-400/10 px-4 py-2 text-sm font-medium text-cyan-100 hover:bg-cyan-400/20"
              >
                Fixtures
              </Link>
              <Link
                to="/"
                className="rounded-lg border border-white/20 bg-white/5 px-4 py-2 text-sm font-medium text-white hover:bg-white/10"
              >
                Club documents
              </Link>
              <Link
                to="/"
                className="rounded-lg border border-white/20 bg-white/5 px-4 py-2 text-sm font-medium text-white hover:bg-white/10"
              >
                About
              </Link>
              <Link
                to="/"
                className="rounded-lg border border-cyan-300/30 bg-cyan-400/10 px-4 py-2 text-sm font-medium text-cyan-100 hover:bg-cyan-400/20"
              >
                Contact
              </Link>
            </div>
          </section>

          <section className="mt-10">
            <RecordsTable hideHeading={true} />
          </section>
        </div>
      </div>
    </div>
  );
}
